import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";

import reportWebVitals from "./reportWebVitals";

const loader = document.querySelector(".loader");
const showLoader = () => loader.className.remove("loader--hide");
const hideLoader = () => loader.classList.add("loader--hide");

const ReactLazyPreload = (importStatement) => {
  const Component = lazy(importStatement);
  Component.preload = importStatement;
  return Component;
};

const loading = () => {
  return (
    <div className="transition bg-transparent loader ease top-1/2 left-1/2"></div>
  );
};

const App = ReactLazyPreload(() => import("./App"));

setTimeout(
  () =>
    ReactDOM.render(
      <React.StrictMode>
        <Suspense fallback={loading}>
          <App hideLoader={hideLoader} showLoader={showLoader} />
        </Suspense>
      </React.StrictMode>,
      document.getElementById("root")
    ),
  1000
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
